<div class="mf-chart">

  <div #mf_chartdiv [id]="'mf-chart__chart_' + country.label"></div>

</div>

